var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFramingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_317_1334)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7629 23.4891C49.0109 24.0954 52.8154 26.077 55.7126 28.9741C58.6789 31.9404 60.689 35.863 61.2383 40.2371H67.0041V45.7629H61.1488C60.4896 49.8848 58.5365 53.5754 55.7126 56.3952C52.8195 59.2882 49.0109 61.2739 44.7629 61.8802V68H39.2371V61.8802C34.9891 61.2739 31.1846 59.2923 28.2915 56.3952C25.4676 53.5713 23.5145 49.8848 22.8553 45.7629H17V40.2371H22.7617C23.311 35.863 25.3211 31.9404 28.2874 28.9741C31.1805 26.0811 34.985 24.0954 39.2331 23.4891V18H44.7588V23.4891H44.7629ZM42 32.4084C47.6763 32.4084 52.2743 37.0104 52.2743 42.6826C52.2743 48.3589 47.6722 52.9569 42 52.9569C36.3237 52.9569 31.7257 48.3548 31.7257 42.6826C31.7257 37.0104 36.3237 32.4084 42 32.4084ZM53.2142 31.4725C50.3455 28.6038 46.3783 26.8257 42 26.8257C37.6217 26.8257 33.6545 28.5998 30.7858 31.4725C27.9172 34.3411 26.139 38.3084 26.139 42.6867C26.139 47.0649 27.9131 51.0322 30.7858 53.9009C33.6545 56.7695 37.6217 58.5477 42 58.5477C46.3783 58.5477 50.3455 56.7736 53.2142 53.9009C56.0828 51.0322 57.861 47.0649 57.861 42.6867C57.8569 38.3044 56.0828 34.3411 53.2142 31.4725Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_1334",
    x1: 128.912,
    y1: 76.2137,
    x2: 64.2309,
    y2: -57.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B947F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106554"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramingIcon);
export default __webpack_public_path__ + "static/media/FramingIcon.fed8634e1371eb5531bc52d0482900e0.svg";
export { ForwardRef as ReactComponent };